import { Injectable } from '@angular/core';
import { Measurement } from '../Modules/informate/models/measurement/measurement';
import { ManagementApiService } from './management-api.service';

@Injectable({
    providedIn: 'root',
})
export class HelperService {
    constructor(private mgmtSvc: ManagementApiService) {}

    //NOTE: This is marked for removal, kindly Invoke MeasurementService.Format() method.
    getCorrectedValue(value: string, unitKey: string): string {
        let rtnValue: string;
        if (value === '') {
            rtnValue = '';
        } else {
            let unitExt: string;
            let defaultExt: string;
            if (unitKey != 'DefaultPercentUnit' && unitKey != 'DefaultAngleUnit') {
                defaultExt = this.mgmtSvc.userDefaults?.find((o) => o.userPreferenceKey == unitKey)?.userPreference;
            }
            switch (unitKey) {
                case 'DefaultAreaUnit':
                    if (defaultExt == 'SqMillimeters') {
                        unitExt = 'mm²';
                    } else if (defaultExt == 'SqMeters') {
                        unitExt = 'm²';
                    } else {
                        unitExt = 'in²';
                    }
                    if (value.toLowerCase().indexOf('mm') != -1) {
                        unitExt = 'mm²';
                    } else if (value.toLowerCase().indexOf('m') != -1) {
                        unitExt = 'm²';
                    } else if (value.toLowerCase().indexOf('in') != -1) {
                        unitExt = 'in²';
                    }

                    break;

                case 'DefaultLengthUnit':
                    unitExt = defaultExt == 'Millimeters' ? 'mm' : '"';
                    if (value.toLowerCase().indexOf('in') != -1 || value.indexOf('"') != -1) {
                        unitExt = '"';
                    } else if (value.toLowerCase().indexOf('m') != -1) {
                        unitExt = 'mm';
                    }
                    break;

                case 'DefaultTemperatureUnit':
                    unitExt = defaultExt == 'Celcius' ? '°C' : '°F';
                    if (value.toLowerCase().indexOf('f') != -1) {
                        unitExt = '°F';
                    } else if (value.toLowerCase().indexOf('c') != -1) {
                        unitExt = '°C';
                    }
                    break;

                case 'DefaultTorqueUnit':
                    if (defaultExt == 'NewtonMeters') {
                        unitExt = 'Nm';
                    } else if (defaultExt == 'PoundsForceFeet') {
                        unitExt = 'Lbf.ft';
                    } else {
                        unitExt = 'Lbf.in';
                    }
                    if (value.toLowerCase().indexOf('nm') != -1) {
                        unitExt = 'Nm';
                    } else if (value.toLowerCase().indexOf('in') != -1 || value.toLowerCase().indexOf('"') != -1 || value.toLowerCase().indexOf("'") != -1) {
                        unitExt = 'Lbf.in';
                    } else if (value.toLowerCase().indexOf('ft') != -1 && value.toLowerCase().indexOf('lbf') != -1) {
                        unitExt = 'Lbf.ft';
                    }
                    break;

                case 'DefaultForceUnit':
                    if (defaultExt == 'KiloNewtons') {
                        unitExt = 'kN';
                    } else if (defaultExt == 'PoundsForce') {
                        unitExt = 'lbf';
                    } else {
                        unitExt = 'N';
                    }
                    if (value.toLowerCase().indexOf('lb') != -1) {
                        unitExt = 'lbf';
                    } else if (value.toLowerCase().indexOf('kn') != -1) {
                        unitExt = 'kN';
                    } else if (value.toLowerCase().indexOf('n') != -1 && value.toLowerCase().indexOf('k') == -1) {
                        unitExt = 'N';
                    }
                    break;

                case 'DefaultWeightUnit':
                    unitExt = defaultExt == 'Kilograms' ? 'kg' : 'lb';
                    if (value.toLowerCase().indexOf('kg') != -1) {
                        unitExt = 'kg';
                    } else if (value.toLowerCase().indexOf('lb') != -1) {
                        unitExt = 'lb';
                    }
                    break;

                case 'DefaultPressureUnit':
                    unitExt = defaultExt == 'Bar' ? 'Bar' : 'Psi';
                    if (value.toLowerCase().indexOf('bar') != -1) {
                        unitExt = 'Bar';
                    } else if (value.toLowerCase().indexOf('psi') != -1) {
                        unitExt = 'Psi';
                    }
                    break;

                case 'DefaultStressUnit':
                    if (defaultExt == 'MegaPascals') {
                        unitExt = 'MPa';
                    } else if (defaultExt == 'PSI') {
                        unitExt = 'Psi';
                    } else {
                        unitExt = 'Bar';
                    }
                    if (value.toLowerCase().indexOf('ps') != -1) {
                        unitExt = 'Psi';
                    } else if (value.toLowerCase().indexOf('mp') != -1) {
                        unitExt = 'MPa';
                    } else if (value.toLowerCase().indexOf('b') != -1) {
                        unitExt = 'bar';
                    }
                    break;

                case 'DefaultPercentUnit':
                    unitExt = defaultExt = '%';
                    break;

                case 'DefaultAngleUnit':
                    unitExt = defaultExt = '°';
                    break;
            }
            rtnValue =
                parseFloat(value)
                    .toFixed(unitKey === 'DefaultAngleUnit' ? 3 : 2)
                    .toString() +
                ' ' +
                unitExt;
        }
        return rtnValue;
    }

    getOutputValue(item: Measurement): string {
        let defaultExt: string;
        if (item != null) {
            switch (item.metric.unit) {
                case 'Degrees':
                    defaultExt = this.mgmtSvc.userDefaults.find((o) => o.userPreferenceKey == 'DefaultAngleUnit')?.userPreference;
                    return defaultExt == item.metric.unit ? item.metric.stringValue : item.imperial.stringValue;

                case 'SqMillimeters':
                    defaultExt = this.mgmtSvc.userDefaults.find((o) => o.userPreferenceKey == 'DefaultAreaUnit')?.userPreference;
                    if (defaultExt == 'SqMillimeters') {
                        return item.metric.stringValue;
                    } else if (defaultExt == 'SqInches') {
                        return item.imperial.stringValue;
                    } else {
                        return (item.metric.value * 0.001).toString() + ' m²';
                    }

                case 'KilogramCubicMeters':
                    defaultExt = this.mgmtSvc.userDefaults.find((o) => o.userPreferenceKey == 'DefaultDensityUnit')?.userPreference;
                    return defaultExt == item.metric.unit ? item.metric.stringValue : item.imperial.stringValue;

                case 'Amps':
                    defaultExt = this.mgmtSvc.userDefaults.find((o) => o.userPreferenceKey == 'DefaultElectricalUnit')?.userPreference;
                    return defaultExt == item.metric.unit ? item.metric.stringValue : item.imperial.stringValue;

                case 'KiloNewtons':
                    defaultExt = this.mgmtSvc.userDefaults.find((o) => o.userPreferenceKey == 'DefaultForceUnit')?.userPreference;
                    if (defaultExt == 'KiloNewtons') {
                        return item.metric.stringValue;
                    } else if (defaultExt == 'PoundsForce') {
                        return item.imperial.stringValue;
                    } else {
                        return (item.metric.value * 0.001).toString() + ' N';
                    }

                case 'Millimeters':
                    defaultExt = this.mgmtSvc.userDefaults.find((o) => o.userPreferenceKey == 'DefaultLengthUnit')?.userPreference;
                    return defaultExt == item.metric.unit ? item.metric.stringValue : item.imperial.stringValue;

                case 'MegaPascals':
                    defaultExt = this.mgmtSvc.userDefaults.find((o) => o.userPreferenceKey == 'DefaultStressUnit')?.userPreference;
                    if (defaultExt == 'MegaPascals') {
                        return item.metric.stringValue;
                    } else if (defaultExt == 'Bar') {
                        return item.imperial.stringValue;
                    } else {
                        return (item.metric.value / 14.504).toString() + ' Psi';
                    }

                case 'Celcius':
                    defaultExt = this.mgmtSvc.userDefaults.find((o) => o.userPreferenceKey == 'DefaultTemperatureUnit')?.userPreference;
                    return defaultExt == item.metric.unit ? item.metric.stringValue : item.imperial.stringValue;

                case 'NewtonMeters':
                    defaultExt = this.mgmtSvc.userDefaults.find((o) => o.userPreferenceKey == 'DefaultTorqueUnit')?.userPreference;
                    if (defaultExt == 'NewtonMeters') {
                        return item.metric.stringValue;
                    } else if (defaultExt == 'PoundsForceInches') {
                        return item.imperial.stringValue;
                    } else {
                        return (item.metric.value / 12).toString() + ' lbf.ft';
                    }

                case 'CubicMeters':
                    defaultExt = this.mgmtSvc.userDefaults.find((o) => o.userPreferenceKey == 'DefaultVolumeUnit')?.userPreference;
                    return defaultExt == item.metric.unit ? item.metric.stringValue : item.imperial.stringValue;

                case 'Kilograms':
                    defaultExt = this.mgmtSvc.userDefaults.find((o) => o.userPreferenceKey == 'DefaultWeightUnit')?.userPreference;
                    return defaultExt == item.metric.unit ? item.metric.stringValue : item.imperial.stringValue;
            }
        }

        return '';
    }

    getOutputWithUnit(item: number, unit: string): string {
        if (item != null) {
            if (unit == 'Percentage') {
                return (item * 100.0).toFixed(2) + ' %';
            }
            return item.toString();
        }
        return '';
    }

    //NOTE: This is marked for removal, kindly Invoke MeasurementService.extractNumarical() method.
    getNumberPart(value: string): number {
        let numberPart = parseFloat(value);
        return numberPart;
    }
}
